export enum FileExtension {
  TXT = 'txt',
  RAR = 'rar',
  ZIP = 'zip',
  MP3 = 'mp3',
  WAV = 'wav',
  JPG = 'jpg',
  JPEG = 'jpeg',
  PNG = 'png',
  PDF = 'pdf',
  PPT = 'ppt',
  PPTX = 'pptx',
  DOC = 'doc',
  DOCX = 'docx',
  XLS = 'xls',
  XLSX = 'xlsx',
  MP4 = 'mp4',
  AVI = 'avi'
}
